export const GET_INDEX_JURIDICAL_PERSONS_ATTEMPT = 'GET_INDEX_JURIDICAL_PERSONS_ATTEMPT';
export type GET_INDEX_JURIDICAL_PERSONS_ATTEMPT = typeof GET_INDEX_JURIDICAL_PERSONS_ATTEMPT;

export const GET_INDEX_JURIDICAL_PERSONS_SUCCESS = 'GET_INDEX_JURIDICAL_PERSONS_SUCCESS';
export type GET_INDEX_JURIDICAL_PERSONS_SUCCESS = typeof GET_INDEX_JURIDICAL_PERSONS_SUCCESS;

export const GET_INDEX_JURIDICAL_PERSONS_FAILURE = 'GET_INDEX_JURIDICAL_PERSONS_FAILURE';
export type GET_INDEX_JURIDICAL_PERSONS_FAILURE = typeof GET_INDEX_JURIDICAL_PERSONS_FAILURE;



// WEBPACK FOOTER //
// ./src/actions/juridical-person/index/Types.tsx